import { useMutation } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'

export const useDownloadGeneralCommentsAttachmentMutation = () => {

    return useMutation({
        mutationFn: async (payload: { fileId: number, generalCommentComponentSid: string}) =>
            (await hcaClientFactory.generalCommentsApi.downloadGeneralCommentFile(payload.fileId, {responseType: 'blob'})).data as unknown as Blob,
    })
}
